import React from 'react';
import PropTypes from 'prop-types';
import treeStyles from '@dtsl/css-tree-view/dist/index.module.css';
import ArrowLeft from '@dtsl/icons/dist/icons/react/ArrowLeft';
import { Button } from '@dtsl/react/dist/components/Button';
import { StackedButton } from '@dtsl/react/dist/components/StackedButton';
const StackButton = _ref => {
  let {
    label,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: treeStyles['sib-tree-view__exp-stackbtn']
  }, /*#__PURE__*/React.createElement(StackedButton, {
    style: {
      border: 'none',
      padding: 0
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    label: label,
    icon: /*#__PURE__*/React.createElement(ArrowLeft, null),
    onClick: onClick
  })));
};
StackButton.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func
};
export default StackButton;